import React from "react";
import styles from "./AccountPendingReviewBanner.module.scss";
import { Typography } from "antd";

interface Props {
  emailSuggestion?: boolean;
  inactive?: boolean;
  isAustraliaAccount?: boolean;
}

const AccountPendingReviewBanner: React.FC<Props> = ({
  emailSuggestion,
  inactive,
  isAustraliaAccount
}) => {
  if (inactive) {
    if (isAustraliaAccount) {
      return (
        <div className={styles.banner}>
          <span>
            We are currently performing a system upgrade. The portal will be
            temporarily unavailable while these improvements are in progress.
            <br />
            We apologise for the inconvenience and appreciate your patience.
          </span>
        </div>
      );
    }

    return (
      <div className={styles.banner}>
        <span>
          Your account is inactive. Please reach out to{" "}
          <Typography.Link href="mailto:support@ipaymy.com">
            support@ipaymy.com
          </Typography.Link>{" "}
          for further assistance.
        </span>
      </div>
    );
  }

  const message = emailSuggestion
    ? "Our team has reached out via email for more information. Please check your email for more details."
    : "Your account is currently under review (up to 48 hours). You'll be notified by email once approved.";

  return (
    <div className={styles.banner}>
      <span>{message}</span>
    </div>
  );
};

export default AccountPendingReviewBanner;
